export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "invoice_payment": {
            "payment_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha de pago"])},
            "amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Monto"])}
          }
        }
      }
    }
  })
}